import { defineMessages } from 'react-intl';
export default defineMessages({
  addressinputRightPN: {
    id: 'address.inputRightPN',
    defaultMessage: '请输入正确手机号',
  },
  addressname: {
    id: 'address.name',
    defaultMessage: '姓名',
  },
  addressinputName: {
    id: 'address.inputName',
    defaultMessage: '请输入姓名',
  },
  addresssex: {
    id: 'address.sex',
    defaultMessage: '性别',
  },
  addressPN: {
    id: 'address.PN',
    defaultMessage: '联系电话',
  },
  addressinputPN: {
    id: 'address.inputPN',
    defaultMessage: '请输入手机号码',
  },
  addressAddress: {
    id: 'address.Address',
    defaultMessage: '收货地址',
  },
  addressselectAddress: {
    id: 'address.selectAddress',
    defaultMessage: '请选择收货地址',
  },
  selectDeliveryArriveTime: {
    id: 'address.selectDeliveryArriveTime',
    defaultMessage: '请选择送达时间',
  },
  addressdoorplateInfo: {
    id: 'address.doorplateInfo',
    defaultMessage: '门牌信息',
  },
  addressinputDoorplate: {
    id: 'address.inputDoorplate',
    defaultMessage: '请输入门牌信息',
  },
  addresssaveAddress: {
    id: 'address.saveAddress',
    defaultMessage: '保存地址',
  },
  addressdeleteAddress: {
    id: 'address.deleteAddress',
    defaultMessage: '删除地址',
  },
  addressconfirmDelete: {
    id: 'address.confirmDelete',
    defaultMessage: '您确定删除该地址吗？',
  },
  addressBirthday: {
    id: 'address.birthday',
    defaultMessage: '生日',
  },
  addressInvalidName: {
    id: 'address.invalidName',
    defaultMessage: '地址信息中姓名不允许含有特殊字符',
  },
  addressInvalidStreet: {
    id: 'address.invalidStreet',
    defaultMessage: '地址信息中门牌信息不允许含有特殊字符',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/address/index.js